import { DateTime } from 'luxon'
import React, { useContext } from 'react'
import { Table } from '../../../components'
import { WemoloLoading } from '../../../components/Wemolo'
import { DeviceContext } from '../DeviceContext'
import { useGetSmsStatusQuery } from './useSmsHooks'
import styles from './SmsResponses.module.css'

export const SmsResponses = () => {
    const deviceContext = useContext(DeviceContext)
    const { data, loading } = useGetSmsStatusQuery(deviceContext.deviceData?.uuid)

    const smsResponsesColumns = [
        { key: 'content', label: 'Response Content' },
        { key: 'delivery_status', label: 'Delivery Status' },
        { key: 'date', label: 'Date' }
    ]
    if (loading) return <WemoloLoading />
    return (
        <div className={styles.root}>
            <Table
                columns={smsResponsesColumns}
                data={
                    data?.map((response) => ({
                        ...response,
                        date: response.date
                            ? DateTime.fromISO(response.date).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
                            : ''
                    })) || []
                }
            />
        </div>
    )
}
